var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"yad1-e2ca8deca19c73a2c715bff94228844399e53400"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/yad1";

import env from '@y2/environments';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { initSentry, OWNERS } from '../../sentry.config.base';

initSentry(env.name, 'yad1', OWNERS.STORM);
